
/* Gallery02 — Photo Art mosaic.
   Lives in assets/ rather than inline in the section: identical behaviour, but
   the browser caches it once for the whole site instead of re-downloading
   ~18 KB inside the HTML on every visit. Everything that used to be baked in
   by Liquid now arrives through the JSON config block the section prints. */
function iqGallery02(root, CFG) {
  var grid = root.querySelector('.iqm__grid');
  if (!grid) return;

  var cells = Array.prototype.slice.call(grid.querySelectorAll('.iqm__cell'));
  var SHUFFLE = CFG.shuffle;

  /* An optional reshuffle of the hanging order. Done ONCE, before the first
     layout — reshuffling on resize would move a photograph out from under the
     cursor. 'day' seeds from the date so every visitor sees the same wall on a
     given day and it turns over at midnight; 'visit' seeds at random. The
     generator is a plain LCG rather than Math.random so the daily order is
     reproducible, which matters if two people are looking at the same wall. */
  function shuffleCells() {
    if (SHUFFLE !== 'day' && SHUFFLE !== 'visit') return;
    var seed;
    if (SHUFFLE === 'day') {
      var d = new Date();
      seed = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    } else {
      seed = Math.floor(Math.random() * 2147483646) + 1;
    }
    var st = seed % 2147483647;
    if (st <= 0) st += 2147483646;
    function rnd() { st = st * 16807 % 2147483647; return (st - 1) / 2147483646; }
    var i, j, t;
    for (i = cells.length - 1; i > 0; i--) {
      j = Math.floor(rnd() * (i + 1));
      t = cells[i]; cells[i] = cells[j]; cells[j] = t;
    }
    /* the touch hint was printed on the first few tiles in source order; move it
       onto the first few of the new order, or it reads as random decoration */
    var hints = Array.prototype.slice.call(grid.querySelectorAll('.iqm__hint'));
    if (hints.length) {
      var tpl = hints[0].cloneNode(true);
      hints.forEach(function (h) { h.parentNode.removeChild(h); });
      cells.slice(0, hints.length).forEach(function (c) {
        c.querySelector('.iqm__tile').appendChild(tpl.cloneNode(true));
      });
    }
  }
  shuffleCells();
  var lb = null, openIdx = -1;
  var ACCENT = CFG.accent;
  var L = CFG.labels;

  /* Ask the CDN for the size this screen will actually paint, rather than a
     width baked in at render time. Shopify honours &width= on any of its URLs,
     including one stored as a plain string, so this works for the piece image
     that comes out of a metafield as well as the two that come from Liquid.
     Rounded up to the next 100 so a handful of URLs stay cacheable across
     devices instead of one per viewport, and capped so a wide desktop never
     pulls the untouched original. */
  function sized(url, cssPx) {
    if (!url) return url;
    /* strip any width the URL already carries, from either position in the
       query string, then put back the one this screen needs */
    var clean = url.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    var dpr = window.devicePixelRatio || 1;
    var w = Math.ceil((cssPx || 600) * dpr / 100) * 100;
    if (w < 400) w = 400;
    if (w > 1600) w = 1600;
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---- the signature -----------------------------------------------------
     Fetched once, as text, and written into each card as a fresh element so
     the write-on starts from nothing every time. Started here rather than on
     first open, so by the time anyone has scrolled the wall and clicked a
     photograph it is already in hand. A failure is silent: the card simply
     carries no signature. */
  var sigMarkup = null, sigPending = null, signStop = null, signTimer = null, signPoll = null;
  function loadSig() {
    if (sigPending || !CFG.sigUrl) return sigPending;
    sigPending = fetch(CFG.sigUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { sigMarkup = t; return t; })
      .catch(function () { sigMarkup = ''; return ''; });
    return sigPending;
  }
  loadSig();

  function placeSig(body) {
    if (!sigMarkup) return;
    if (body.querySelector('.iqm__sign')) return;
    var wrap = document.createElement('div');
    wrap.className = 'iqm__sign';
    wrap.innerHTML = sigMarkup;
    var afterText = body.querySelector('.iqm__lb-text');
    if (afterText && afterText.parentNode) {
      afterText.parentNode.insertBefore(wrap, afterText.nextSibling);
    } else {
      body.appendChild(wrap);
    }
    watchSign(wrap);
  }

  /* Start the write-on when the signature is actually on screen, not when the
     card opened. On a phone the card is one tall scrolling column and the
     sign-off sits below the fold — the animation used to be over before anyone
     scrolled down to it. On a wide screen it is in view from the first frame,
     so it behaves exactly as it did. The delay in the CSS still applies either
     way, so it reads as a sign-off rather than firing the instant it lands.

     Measured with getBoundingClientRect on scroll rather than through an
     IntersectionObserver: the panel is a fixed overlay with its own scroller
     and a pinned body underneath it, and an observer proved unreliable in that
     arrangement. A rect test has no such doubts.

     Two safeguards, because an unwritten signature is an INVISIBLE one:
     the element is only pulled back to the start (.is-armed) at the moment a
     watcher is actually running, and a long stop releases it regardless. Any
     path that fails leaves the signature written and on the card. */
  function stopSignWatch() {
    if (signStop) { signStop(); signStop = null; }
    if (signTimer) { clearTimeout(signTimer); signTimer = null; }
    if (signPoll) { clearInterval(signPoll); signPoll = null; }
  }

  function watchSign(wrap) {
    stopSignWatch();
    if (!wrap || !wrap.querySelector('.iqs-sweep')) return;

    var released = false;
    function release() {
      if (released) return;
      released = true;
      stopSignWatch();
      wrap.classList.add('is-writing');
    }
    function inView() {
      if (!document.contains(wrap)) return false;
      var r = wrap.getBoundingClientRect();
      if (!r.height && !r.width) return false;
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      return r.top < h + 40 && r.bottom > 0;
    }
    function check() { if (inView()) release(); }

    var panel = wrap.parentNode;
    while (panel && panel !== document.body && panel.className !== undefined &&
           String(panel.className).indexOf('iqm-lb__panel') === -1) { panel = panel.parentNode; }
    var scroller = (panel && panel.addEventListener) ? panel : null;

    wrap.classList.add('is-armed');

    /* The scroll listeners make the release feel instant; the timer is what
       makes it CERTAIN. requestAnimationFrame and scroll events are both
       frozen while a tab is in the background, and momentum scrolling on iOS
       can swallow the last event of a flick — a slow poll answers the only
       question that matters, "is it on screen yet", without depending on any
       of that. Three measurements a second, and only while a card is open. */
    if (scroller) scroller.addEventListener('scroll', check, { passive: true });
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    signStop = function () {
      if (scroller) scroller.removeEventListener('scroll', check);
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
    signPoll = setInterval(check, 300);

    /* Last resort, and deliberately narrow: release only if the signature has
       no measurable box at all, because then the poll can never release it and
       an unwritten signature is an invisible one. A signature that is merely
       further down the card is left alone — the reader gets the write-on
       whenever they reach it, however long they take. */
    signTimer = setTimeout(function () {
      var r = wrap.getBoundingClientRect();
      if (!document.contains(wrap) || (!r.height && !r.width)) release();
    }, 30000);

    check();
  }

  /* ---- the room shot -----------------------------------------------------
     Built on demand from the tile's data attributes. Whichever comes first:
     the tile nears the viewport and the browser has an idle moment, or a
     pointer actually touches the tile — the second path is what guarantees
     the picture is on its way before the flash finishes. */
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
  function mountRoom(tile) {
    if (!tile || tile.getAttribute('data-room-on')) return;
    var src = tile.getAttribute('data-room');
    if (!src) return;
    tile.setAttribute('data-room-on', '1');
    var img = document.createElement('img');
    img.className = 'iqm__room';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    var v = tile.getAttribute('data-room-srcset'); if (v) img.srcset = v;
    v = tile.getAttribute('data-room-sizes');      if (v) img.sizes = v;
    v = tile.getAttribute('data-room-pos');        if (v) img.style.objectPosition = v;
    v = tile.getAttribute('data-room-w');          if (v) img.width = v;
    v = tile.getAttribute('data-room-h');          if (v) img.height = v;
    img.src = src;
    var flash = tile.querySelector('.iqm__flash');
    if (flash) { tile.insertBefore(img, flash); } else { tile.appendChild(img); }
  }

  if ('IntersectionObserver' in window) {
    var roomIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        roomIO.unobserve(e.target);
        var t = e.target;
        idle(function () { mountRoom(t); });
      });
    }, { rootMargin: '250px 0px' });
    cells.forEach(function (c) {
      var t = c.querySelector('.iqm__tile');
      if (t && t.getAttribute('data-room')) roomIO.observe(t);
    });
  } else {
    cells.forEach(function (c) { mountRoom(c.querySelector('.iqm__tile')); });
  }

  /* ---- masonry -----------------------------------------------------------
     Each photograph goes into whichever column is shortest so far — CSS grid's
     own auto-placement never backfills, which is what left the holes and a tail
     running ~1570px ragged on this set. Then every column that still falls
     short is closed with a filler of exactly the missing height, measured in
     real pixels, so the wall ends level however many photographs are on it.
     With no Filler blocks the wall just ends where it ends. */
  var fillerSrc = root.querySelector('.iqm__filler-src');
  var fillerTpl = fillerSrc ? Array.prototype.slice.call(fillerSrc.children) : [];
  var LINES = fillerTpl.map(function (t) {
    var el = t.querySelector('.iqm__filler-text');
    return el ? el.textContent.trim() : '';
  }).filter(function (t) { return t !== ''; });
  var CYCLE = CFG.cycleMs;
  var CAMK  = CFG.camScale;
  var FLAK  = CFG.flashScale;

  /* The flash goes above the line and the camera below it, both sized from the
     panel the script just measured — never from a slider. A panel much wider
     than it is tall lays them out in a row; one with no room for them shows
     the line alone rather than a speck. */
  /* ⚑ `is-wide` NEEDS REAL WIDTH, NOT JUST A RATIO — 2026-08-24.
     The row layout (flash | words | camera) was chosen on the aspect ratio
     alone. On a phone a column is ~189px wide, so a 120px-tall filler scored
     1.57 and went row-wise inside 189px: the words got a 64px-wide channel, the
     block rendered 173px tall inside a 120px panel, and overflow:hidden sliced
     the top off the quotation. That is the broken filler at the foot of the
     Photo Art wall. The same thing happened at 459×91 and 459×113 on the Words
     wall on desktop — measured, both overflowing their own panel.
     380px is the narrowest column where three things side by side still leave
     the words a readable measure. */
  function dress(el, h, w) {
    var base;
    if (w / h > 1.45 && w >= 380) {
      el.classList.add('is-wide');
      if (h < 108) { el.classList.add('no-cam'); el.classList.add('no-flash'); return; }
      base = Math.min(h * 0.56, w * 0.20, 300);
    } else {
      /* The old figures assumed a desktop column. On a phone a filler is ~170px
         wide and often under 350 tall, which tripped the "no room" branch and
         dropped BOTH drawings — where the background version they replaced had
         always drawn something. These let them shrink instead, and only give up
         when there is genuinely nothing left. */
      var words = h > 520 ? 190 : (h > 300 ? 150 : 112);
      var free  = h - 44 - words;
      if (free < 60) { el.classList.add('no-cam'); el.classList.add('no-flash'); return; }
      if (free < 150) { el.classList.add('no-flash'); }
      base = Math.min(w * 0.5, free * 0.66, 360);
      if (base < 38) { el.classList.add('no-cam'); el.classList.add('no-flash'); return; }
    }
    var cam = Math.round(base * CAMK / 100);
    el.style.setProperty('--iqm-camw', cam + 'px');
    el.style.setProperty('--iqm-flaw', Math.round(base * 0.52 * FLAK / 100) + 'px');
    el.style.setProperty('--iqm-camgap', Math.round(Math.max(16, cam * 0.15)) + 'px');
    el.style.setProperty('--iqm-flagap', Math.round(Math.max(18, cam * 0.20)) + 'px');
  }
  /* ⚑ MEASURE, THEN STRIP — 2026-08-24.
     dress() sizes the drawings from arithmetic, but the words are typeset by
     the browser and their real height is only knowable afterwards. A filler is
     a FIXED height (the exact deficit the column has to make up), so anything
     that does not fit is not clipped politely — it is beheaded, and the quote
     starts mid-sentence.
     So after layout, every filler is measured against its own panel and stripped
     back until it fits: lose the flash, then the camera, then drop to a smaller
     face, and finally hide the words rather than show half a sentence. Each step
     re-measures; nothing here is predicted. */
  function fitFillers() {
    Array.prototype.slice.call(grid.querySelectorAll('.iqm__filler')).forEach(function (el) {
      var body = el.querySelector('.iqm__filler-body');
      if (!body) return;
      el.classList.remove('is-cramped');
      var room = function () { return el.clientHeight - 16; };
      var over = function () { return body.getBoundingClientRect().height > room(); };
      if (!over()) return;
      el.classList.add('no-flash');
      if (!over()) return;
      el.classList.add('no-cam');
      if (!over()) return;
      el.classList.add('is-cramped');
      if (!over()) return;
      var words = el.querySelector('.iqm__filler-words');
      if (words) { words.style.minHeight = '0'; }
      if (!over() || !words) return;
      words.style.display = 'none';
    });
  }

  var cycleTimer = null;

  /* One filler often has to carry several lines — on a wide screen two columns
     may be short, on a phone only one. Each tile walks the same list from a
     different starting point, so with as many lines as tiles they never show
     the same sentence at once, and a lone filler cycles through all of them. */
  function startCycle() {
    if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
    if (!CYCLE || LINES.length < 2) return;
    var groups = Array.prototype.slice.call(grid.querySelectorAll('.iqm__filler-words'))
      .map(function (box) { return { box: box, text: box.querySelector('.iqm__filler-text') }; })
      .filter(function (g) { return g.text; });
    if (!groups.length) return;

    /* Pin each block to the tallest line it will ever show. Measured once per
       layout, with every line tried in place, so it is the real rendered height
       at this column width rather than a guess. */
    groups.forEach(function (g) {
      var keep = g.text.textContent, tallest = 0;
      g.box.style.minHeight = '';
      LINES.forEach(function (line) {
        g.text.textContent = line;
        tallest = Math.max(tallest, g.box.getBoundingClientRect().height);
      });
      g.text.textContent = keep;
      g.box.style.minHeight = Math.ceil(tallest) + 'px';
    });

    var step = 0;
    cycleTimer = setInterval(function () {
      step++;
      groups.forEach(function (g, i) {
        g.box.classList.add('is-out');
        setTimeout(function () {
          g.text.textContent = LINES[(step + i) % LINES.length];
          g.box.classList.remove('is-out');
        }, 700);
      });
    }, CYCLE);
  }
  var columns = [];
  var busy = false;

  function colCount() {
    var v = parseInt(getComputedStyle(grid).getPropertyValue('--iqm-cols'), 10);
    return (v && v > 0) ? v : 1;
  }

  function layout() {
    if (busy) return;
    busy = true;

    var n = colCount();

    if (columns.length !== n) {
      columns.forEach(function (c) { c.remove(); });
      columns = [];
      var k;
      for (k = 0; k < n; k++) {
        var col = document.createElement('div');
        col.className = 'iqm__col';
        grid.appendChild(col);
        columns.push(col);
      }
    } else {
      columns.forEach(function (c) {
        Array.prototype.slice.call(c.querySelectorAll('.iqm__filler')).forEach(function (f) { f.remove(); });
      });
    }

    // predicted heights are enough to choose a column; the real measurement
    // happens afterwards, so a rounding error here costs nothing
    var gap  = parseFloat(getComputedStyle(grid).columnGap) || 0;
    var colw = (grid.getBoundingClientRect().width - (n - 1) * gap) / n;
    var predicted = [];
    var i;
    for (i = 0; i < n; i++) predicted.push(0);

    cells.forEach(function (cell) {
      var r = parseFloat(cell.querySelector('.iqm__tile').getAttribute('data-ar')) || 1;
      var c = 0;
      for (i = 1; i < n; i++) { if (predicted[i] < predicted[c]) c = i; }
      columns[c].appendChild(cell);
      predicted[c] += (colw / r) + gap;
    });

    function place(col, h, w, idx) {
      var src = fillerTpl[idx % fillerTpl.length];
      var el = document.createElement('div');
      el.className = 'iqm__filler';
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-dark', src.getAttribute('data-dark') || '0');
      el.innerHTML = src.innerHTML;
      el.style.height = h + 'px';
      if (h > 260) el.classList.add('is-tall');
      if (h > 520) el.classList.add('is-xl');
      dress(el, h, w);
      col.appendChild(el);
    }

    if (fillerTpl.length) {
      var heights = columns.map(function (c) { return c.getBoundingClientRect().height; });
      var target = Math.max.apply(null, heights);
      var m = 0;
      for (i = 0; i < n; i++) {
        // under ~90px a filler reads as a mistake rather than as breathing room
        var deficit = target - heights[i] - gap;
        if (deficit < 90) continue;
        place(columns[i], deficit, colw, m); m++;
      }
      /* ⚑ A LEVEL WALL STILL WANTS A CLOSING PANEL — 2026-08-24.
         When every column happens to land within 90px of the tallest, no filler
         was placed at all and the wall simply stopped on a photograph. That is
         what "the filler is missing" looked like on the Words wall at 2-up.
         One panel per column keeps the bottom flat AND gives the wall a closing
         line to read, which is what the fillers are for. */
      if (m === 0) {
        var closeH = Math.max(180, Math.round(colw * 0.62));
        for (i = 0; i < n; i++) { place(columns[i], closeH + Math.round(target - heights[i] - gap), colw, i); }
      }
    }

    busy = false;
    startCycle();
    fitFillers();
  }

  layout();
  if (window.ResizeObserver) { new ResizeObserver(layout).observe(grid); }
  window.addEventListener('resize', layout);
  window.addEventListener('load', layout);

  /* overflow:hidden does not hold iOS. Pin the body at the current offset and
     put the reader back exactly where they were on close. */
  var lockY = 0;
  function lockPage() {
    if (document.body.classList.contains('iqm-locked')) return;   /* INT 2026-08-30: already pinned, so pageYOffset is 0 and re-reading it would
                                                          destroy the saved position. Next/Prev re-enter open() without closing. */
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = (-lockY) + 'px';
    document.body.classList.add('iqm-locked');
  }
  function unlockPage() {
    document.body.classList.remove('iqm-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockY);
  }

  function close() {
    stopSignWatch();
    if (lb) { lb.remove(); lb = null; }
    unlockPage();
    if (openIdx >= 0 && cells[openIdx]) cells[openIdx].querySelector('.iqm__tile').focus({ preventScroll: true });
    openIdx = -1;
  }

  function open(i) {
    if (lb) { lb.remove(); lb = null; }
    var cell  = cells[i];
    var store = cell.querySelector('.iqm__store');
    var full  = store.getAttribute('data-full');
    var room  = store.getAttribute('data-room') || '';
    var piece = store.getAttribute('data-piece') || '';

    lb = document.createElement('div');
    lb.className = 'iqm-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.style.setProperty('--iqm-lb-accent', ACCENT);

    var panel = document.createElement('div');
    panel.className = 'iqm-lb__panel';

    var artCol = document.createElement('div');
    artCol.className = 'iqm-lb__art';
    var fig = document.createElement('div');
    fig.className = 'iqm-lb__figure';
    /* The tile has ALREADY downloaded this photograph, at whatever width its
       srcset chose. Open on that file — it paints out of cache in the same
       frame — then quietly upgrade to the 1400px master once it lands. Loading
       the master cold left the figure empty for as long as the fetch took. */
    var artEl = cell.querySelector('.iqm__art');
    var thumb = (artEl && (artEl.currentSrc || artEl.src)) || full;

    /* How big the picture is about to be drawn. Worked out from the viewport
       rather than measured, because the card is still detached at this point —
       getBoundingClientRect on it would return zeros and quietly send everyone
       the same fallback size.

       This mirrors .iqm-lb__figure's own rule:
           height: min(clamp(280px, 62vh, 660px), 86vw)
       ⚠ If that rule changes, change this with it. */
    var figPx = Math.min(
      Math.max(280, Math.min(window.innerHeight * 0.62, 660)),
      window.innerWidth * 0.86
    );
    full  = sized(full,  figPx);
    room  = sized(room,  figPx);
    piece = sized(piece, figPx);

    var img = document.createElement('img');
    img.src = thumb;
    img.setAttribute('data-view', 'art');
    img.alt = store.getAttribute('data-title') || '';
    fig.appendChild(img);
    artCol.appendChild(fig);

    if (thumb !== full) {
      var hi = new Image();
      hi.onload = function () {
        // only if the reader has not switched to another view in the meantime
        if (img.getAttribute('data-view') === 'art') img.src = full;
      };
      hi.src = full;
    }

    // Only the views that actually have an image. A photograph with no piece
    // chosen in the theme editor simply shows two buttons instead of three.
    var VIEWS = [[L.art, full, 'art']];
    if (room)  VIEWS.push([L.room, room, 'room']);
    if (piece) VIEWS.push([L.piece, piece, 'piece']);

    /* The room shot and the piece are big files that nothing has asked for yet,
       so the first press of a button used to sit there waiting on the network.
       Fetch them the moment the reading view opens — by the time anyone reads
       the writing and reaches for a button they are already in the cache. */
    VIEWS.slice(1).forEach(function (v) { var pre = new Image(); pre.src = v[1]; });

    /* Swap only once the new file has decoded, so the picture never blanks out
       mid-change. From cache this fires in the same tick. */
    function swap(src, key) {
      img.setAttribute('data-view', key);
      if (img.getAttribute('src') === src) return;
      fig.classList.add('is-wait');
      var n = new Image();
      n.onload = n.onerror = function () {
        if (img.getAttribute('data-view') !== key) return;
        img.src = src;
        fig.classList.remove('is-wait');
      };
      n.src = src;
      if (n.complete) { img.src = src; fig.classList.remove('is-wait'); }
    }

    if (VIEWS.length > 1) {
      var views = document.createElement('div');
      views.className = 'iqm-lb__views';
      var viewBtns = [];
      VIEWS.forEach(function (v, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = v[0];
        if (k === 0) b.classList.add('is-on');
        b.addEventListener('click', function () {
          views.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          swap(v[1], v[2]);
        });
        viewBtns.push(b);
        views.appendChild(b);
      });
      artCol.appendChild(views);

      /* INT 2026-08-30, Nils: "The images in the Photo Wall cards can not be
         swiped like in Word wall." A sideways swipe across the picture now steps
         through the same views the buttons offer, on BOTH cards, and it does it
         by firing the button's own click so there is exactly one place that
         changes state. The thresholds are the wall tile's — 34px, and clearly
         more sideways than down — so the gesture feels the same in the card as
         it does on the wall, and a vertical scroll can never flip the view. */
      var _sx = 0, _sy = 0;
      fig.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; _sx = t.clientX; _sy = t.clientY;
      }, { passive: true });
      fig.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0], dx = t.clientX - _sx, dy = t.clientY - _sy;
        if (Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        var cur = 0;
        viewBtns.forEach(function (b, k) { if (b.classList.contains('is-on')) cur = k; });
        viewBtns[(cur + (dx < 0 ? 1 : -1) + viewBtns.length) % viewBtns.length].click();
      }, { passive: true });
    }

    var body = document.createElement('div');
    body.className = 'iqm-lb__body';

    var nav = document.createElement('div');
    nav.className = 'iqm-lb__nav';
    var SVG = function (d) {
      return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" ' +
             'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    };
    [['-1', SVG('M10 3L5 8l5 5'), 'Previous'], ['count', (i + 1) + ' / ' + cells.length, ''],
     ['1', SVG('M6 3l5 5-5 5'), 'Next'], ['0', SVG('M4 4l8 8M12 4l-8 8'), 'Close']].forEach(function (item) {
      if (item[0] === 'count') {
        var s = document.createElement('span');
        s.className = 'iqm-lb__count'; s.textContent = item[1];
        nav.appendChild(s); return;
      }
      var b = document.createElement('button');
      b.type = 'button'; b.innerHTML = item[1]; b.setAttribute('aria-label', item[2]);
      if (item[0] === '0') b.classList.add('is-close');
      b.addEventListener('click', function () {
        var d = parseInt(item[0], 10);
        if (!d) { close(); return; }
        var next = (openIdx + d + cells.length) % cells.length;
        openIdx = -1; open(next);
      });
      nav.appendChild(b);
    });

    body.appendChild(nav);
    body.insertAdjacentHTML('beforeend', store.innerHTML);

    panel.appendChild(artCol);
    panel.appendChild(body);
    lb.appendChild(panel);
    /* INT 2026-08-30: lift the close out of the nav row and pin it to the panel,
       top right over the picture. is-close is kept so anything else that looks
       for it still finds it; iqm-lb__x carries the look, since the nav rules no
       longer reach it once it is out of the nav. */
    var closeBtn = nav.querySelector('button.is-close');
    if (closeBtn) { closeBtn.classList.add('iqm-lb__x'); panel.appendChild(closeBtn); }
    document.body.appendChild(lb);
    lockPage();
    openIdx = i;

    /* Sign off under the description, the way a piece of writing is signed
       rather than stamped at the foot of the page. AFTER the card is in the
       document — the watcher measures the signature's position, and on a
       detached node every measurement is zero. If the outlines have not landed
       yet, drop them in when they do, but only if this card is still open. */
    if (sigMarkup) {
      placeSig(body);
    } else if (sigPending) {
      sigPending.then(function () {
        if (lb && lb.contains(body)) placeSig(body);
      });
    }

    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    if (closeBtn) closeBtn.focus();

    /* Warm the two photographs either side, a beat later so they never compete
       with this one. Arrow keys and the ‹ › buttons then open instantly. */
    setTimeout(function () {
      [-1, 1].forEach(function (d) {
        var c = cells[(i + d + cells.length) % cells.length];
        if (!c) return;
        var st = c.querySelector('.iqm__store');
        /* INT 2026-08-28: size the neighbour the same way the open card is sized.
           data-full is emitted by Liquid at width=2000; the card's own three views
           all go through sized(..., figPx) and land at ~1100 on a phone, but this
           warm used the raw attribute. Measured: one tile tap pulled a single
           2,412 KB neighbour. figPx is in scope here (open() runs 466-636). */
        if (st) { var pre = new Image(); pre.src = sized(st.getAttribute('data-full'), figPx); }
      });
    }, 450);
  }

  /* Touch: a swipe across a tile moves between the photograph and the room
     shot, which is what the two dots are announcing. A tap still opens the
     reading view — and a swipe ends in a click, so that one is swallowed. */
  cells.forEach(function (cell, i) {
    var tile = cell.querySelector('.iqm__tile');
    var dots = tile.querySelector('.iqm__dots');
    var swiped = false;

    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
      tile.addEventListener(ev, function () { mountRoom(tile); }, { passive: true });
    });

    tile.addEventListener('click', function () {
      if (swiped) { swiped = false; return; }
      open(i);
    });

    if (!dots) return;
    var x0 = 0, y0 = 0;
    tile.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; swiped = false;
    }, { passive: true });
    tile.addEventListener('touchend', function (e) {
      var t  = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      // sideways, and clearly more sideways than down, or scrolling would flip it
      if (Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      swiped = true;
      tile.classList.toggle('is-room');
      var on = tile.classList.contains('is-room') ? 1 : 0;
      Array.prototype.slice.call(dots.children).forEach(function (d, k) {
        if (k === on) { d.classList.add('is-on'); } else { d.classList.remove('is-on'); }
      });
    }, { passive: true });
  });

  /* ------------------------------------------------------- find a photograph
     Nils, 2026-09-01: "Maybe a search bar here too? If people know the title
     they can find it." This is the Words of Intention find box, ported across
     unchanged in behaviour: starts-with matches rank above matches-anywhere,
     up to 8 rows, arrow keys and Enter, click outside to close, and choosing a
     row scrolls the wall to that photograph and pulses it. It does NOT open
     the card, which is the same rule the deep link follows.
     Titles come from .iqm__store data-title; the paired Word shown on the right
     of each row is read from the card's own Word link. */
  (function wireFind() {
    var wrap = root.querySelector('.iqm__find');
    if (!wrap) return;
    var input = wrap.querySelector('.iqm__find-input');
    var list = wrap.querySelector('.iqm__find-list');
    var none = wrap.querySelector('.iqm__find-none');
    if (!input || !list) return;

    var items = cells.map(function (cell) {
      var store = cell.querySelector('.iqm__store');
      var t = (store && store.getAttribute('data-title')) || '';
      var word = '';
      var wl = store && store.querySelector('.iqm__word a');
      if (wl) word = wl.textContent.trim();
      return { cell: cell, title: t, key: t.toLowerCase(), word: word };
    }).filter(function (it) { return it.title; });

    var shown = [];
    var active = -1;

    function close() {
      list.hidden = true;
      list.innerHTML = '';
      shown = [];
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function pulse(cell) {
      cell.classList.remove('is-found');
      /* reflow, or re-adding the class in the same frame does nothing */
      void cell.offsetWidth;
      cell.classList.add('is-found');
      var done = function () {
        cell.classList.remove('is-found');
        cell.removeEventListener('animationend', done);
      };
      cell.addEventListener('animationend', done);
      /* belt and braces: animationend never fires under reduced motion */
      setTimeout(done, 6000);
    }

    function go(item) {
      if (!item) return;
      close();
      input.blur();
      try {
        item.cell.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        item.cell.scrollIntoView();
      }
      /* let the scroll settle, or the pulse plays off-screen */
      setTimeout(function () { pulse(item.cell); }, 420);
    }

    function mark(title, q) {
      var i = title.toLowerCase().indexOf(q);
      if (i < 0) return title;
      return title.slice(0, i) + '<b>' + title.slice(i, i + q.length) + '</b>' + title.slice(i + q.length);
    }

    function render() {
      var q = input.value.trim().toLowerCase();
      if (!q) { close(); if (none) none.hidden = true; return; }

      var starts = items.filter(function (it) { return it.key.indexOf(q) === 0; });
      var within = items.filter(function (it) { return it.key.indexOf(q) > 0; });
      shown = starts.concat(within).slice(0, 8);

      if (none) none.hidden = shown.length > 0;
      if (!shown.length) { list.hidden = true; list.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }

      list.innerHTML = shown.map(function (it, i) {
        return '<li role="option" data-i="' + i + '" aria-selected="false">' +
          '<span>' + mark(it.title, q) + '</span>' +
          (it.word ? '<em>' + it.word + '</em>' : '') + '</li>';
      }).join('');
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }

    function highlight(n) {
      var lis = list.querySelectorAll('li');
      if (!lis.length) return;
      if (active >= 0 && lis[active]) { lis[active].classList.remove('is-active'); lis[active].setAttribute('aria-selected', 'false'); }
      active = (n + lis.length) % lis.length;
      lis[active].classList.add('is-active');
      lis[active].setAttribute('aria-selected', 'true');
      lis[active].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', render);
    input.addEventListener('focus', function () { if (input.value.trim()) render(); });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) render(); highlight(active + 1); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); return; }
      if (e.key === 'Enter') {
        e.preventDefault();
        go(shown[active >= 0 ? active : 0]);
      }
    });

    list.addEventListener('click', function (e) {
      var li = e.target.closest('li[data-i]');
      if (li) go(shown[parseInt(li.getAttribute('data-i'), 10)]);
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  })();

  /* --------------------------------------------------- deep link (?photo=)
     Nils, 2026-09-01. The Words of Intention card links here as
     /pages/photo-art?photo=everyday-hero, so an arrival has to land on that
     photograph rather than at the top of the wall. Scroll, then open the card.
     The parameter is removed from the address bar afterwards so a reload or a
     shared URL does not re-open the card. */
  (function wireDeepLink() {
    var q = new URLSearchParams(window.location.search).get('photo');
    if (!q && window.location.hash.indexOf('#photo-') === 0) {
      q = window.location.hash.slice(7);
    }
    if (!q) return;
    var want = String(q).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (!want) return;

    var idx = -1;
    cells.forEach(function (cell, i) {
      if (idx > -1) return;
      var h = (cell.getAttribute('data-photo') || '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (h === want) idx = i;
    });
    if (idx < 0) return;

    /* Nils, 2026-09-01: land on the photograph and PULSE it, do not open the
       card. Same behaviour and the same timings as the Words of Intention wall,
       whose search box has always worked this way. The reflow between removing
       and adding the class is what makes the animation restart; animationend
       clears it, with a timeout as belt and braces because animationend never
       fires under reduced motion. */
    /* 2026-09-01, Nils: "A little slow". The find box below scrolls smoothly
       because you are watching the wall travel. Arriving from another page there
       is nothing to watch, so this one JUMPS: two animation frames for layout,
       then the pulse almost at once. About 680ms of deliberate delay removed. */
    var cell = cells[idx];
    var land = function () {
      try {
        cell.scrollIntoView({ behavior: 'auto', block: 'center' });
      } catch (e) {
        cell.scrollIntoView();
      }
      setTimeout(function () {
        cell.classList.remove('is-found');
        void cell.offsetWidth;
        cell.classList.add('is-found');
        var done = function () {
          cell.classList.remove('is-found');
          cell.removeEventListener('animationend', done);
        };
        cell.addEventListener('animationend', done);
        setTimeout(done, 6000);
      }, 80);
    };
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () { requestAnimationFrame(land); });
    } else {
      setTimeout(land, 60);
    }

    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('photo');
      history.replaceState(null, '', u.pathname + (u.search || ''));
    } catch (e) { /* older browser, leave the address bar alone */ }
  })();

  document.addEventListener('keydown', function (e) {
    if (!lb) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight') { var n = (openIdx + 1) % cells.length; openIdx = -1; open(n); }
    if (e.key === 'ArrowLeft')  { var p = (openIdx - 1 + cells.length) % cells.length; openIdx = -1; open(p); }
  });
}

/* One config block per section instance, printed next to the wall. */
(function boot() {
  function start() {
    var nodes = document.querySelectorAll('[data-iqm-cfg]');
    Array.prototype.forEach.call(nodes, function (root) {
      if (root.getAttribute('data-iqm-on')) return;
      root.setAttribute('data-iqm-on', '1');
      var el = document.getElementById(root.getAttribute('data-iqm-cfg'));
      var cfg = {};
      if (el) { try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = {}; } }
      iqGallery02(root, cfg);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* the theme editor rebuilds a section in place */
  document.addEventListener('shopify:section:load', start);
})();
